var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3890",
    "data-name": "Group 3890",
    transform: "translate(15848 -8566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2979",
    "data-name": "Rectangle 2979",
    width: 16,
    height: 16,
    transform: "translate(-15848 8566)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "question-mark",
    transform: "translate(-15847.001 8567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8239",
    "data-name": "Path 8239",
    d: "M6.907,0A7,7,0,1,0,14,6.906,7,7,0,0,0,6.907,0Zm-.021,11.26H6.848a1.019,1.019,0,0,1,.024-2.038h.035a1.019,1.019,0,1,1-.02,2.038Zm2.5-4.97a4.628,4.628,0,0,1-.836.748l-.427.295a1.161,1.161,0,0,0-.429.523,1.082,1.082,0,0,0-.066.438v.069H6l0-.138a1.784,1.784,0,0,1,.269-1.177,6.927,6.927,0,0,1,1.217-.979,1.284,1.284,0,0,0,.288-.295,1.037,1.037,0,0,0,.247-.6,1.178,1.178,0,0,0-.224-.7A.932.932,0,0,0,7,4.171a.88.88,0,0,0-.816.377,1.514,1.514,0,0,0-.247.814v.07H4.252l0-.073a2.556,2.556,0,0,1,1.092-2.2,2.877,2.877,0,0,1,1.582-.415,3.415,3.415,0,0,1,2.041.588A2.038,2.038,0,0,1,9.8,5.085,2.012,2.012,0,0,1,9.391,6.291Z",
    transform: "translate(0 0)",
    fill: "#1f699d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.95158ff1208f5fa200287969fea31f3c.svg";
export { ForwardRef as ReactComponent };